import { Botao } from '../../../components/Botao'
import { CampoDeSelecao, CampoDeTexto } from '../../../components/campos'
import type { FiltrosDeOs as Criterios, RegimeDaOs, SituacaoDaOs } from '../../../types/ordemDeServico'
import { SITUACAO_DA_OS, SITUACOES_NA_ORDEM_DO_CICLO } from '../situacaoDaOs'
import { OS } from '../textosDaOs'

/**
 * O recorte da lista: mês, modelo e situação.
 *
 * A situação é filtro de verdade, e não um agrupamento visual, porque o servidor projeta a mesma
 * expressão que pinta cada linha — filtro e linha não têm como discordar. Não há filtro de
 * "atrasada" porque não existe atraso apurável na emissão: o contrato não datou o "início de cada
 * mês", e a ausência de ordem aparece na faixa acima, dita pelo que ela é.
 *
 * @param props os critérios correntes, como alterá-los e como limpar
 * @returns a barra de filtros
 */
export function FiltrosDeOs({
  filtros,
  alterar,
  limpar,
  temFiltro,
}: {
  filtros: Criterios
  alterar: (mudanca: Partial<Criterios>) => void
  limpar: () => void
  temFiltro: boolean
}) {
  return (
    <section aria-label="Filtros das ordens de serviço" className="cartao grid gap-3 p-4 sm:grid-cols-3">
      <CampoDeTexto
        rotulo={OS.competencia}
        // `type="month"` entrega exatamente `AAAA-MM`, que é o formato que o servidor espera: um
        // campo de texto livre aqui produziria "05/2026" e um 400 sem explicação.
        type="month"
        value={filtros.competencia}
        onChange={(evento) => alterar({ competencia: evento.target.value })}
      />

      <CampoDeSelecao
        rotulo="Modelo"
        value={filtros.regime}
        onChange={(evento) => alterar({ regime: evento.target.value as RegimeDaOs | '' })}
      >
        <option value="">Todos</option>
        <option value="SUSTENTACAO_INFRAESTRUTURA">{OS.regimes.SUSTENTACAO_INFRAESTRUTURA}</option>
        <option value="PROJETO_PONTO_DE_FUNCAO">{OS.regimes.PROJETO_PONTO_DE_FUNCAO}</option>
      </CampoDeSelecao>

      <CampoDeSelecao
        rotulo={OS.situacao}
        value={filtros.situacao}
        onChange={(evento) => alterar({ situacao: evento.target.value as SituacaoDaOs | '' })}
      >
        <option value="">Todas</option>
        {SITUACOES_NA_ORDEM_DO_CICLO.map((situacao) => (
          <option key={situacao} value={situacao}>
            {SITUACAO_DA_OS[situacao].rotulo}
          </option>
        ))}
      </CampoDeSelecao>

      {temFiltro && (
        <div className="sm:col-span-3">
          <Botao tamanho="pequeno" onClick={limpar}>
            {OS.limparFiltros}
          </Botao>
        </div>
      )}
    </section>
  )
}
